import createIcon from '../../createIcon';

/**
 * @component @name SubdirectoryArrowLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNSA4LjVMMTEuOTIgOS45Mkw4LjMzIDEzLjVIMTcuNVYzLjVIMTkuNVYxNS41SDguMzNMMTEuOTIgMTkuMDhMMTAuNSAyMC41TDQuNSAxNC41TDEwLjUgOC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SubdirectoryArrowLeft = createIcon('SubdirectoryArrowLeft', [
  [
    'path',
    {
      d: 'M10.5 8.5L11.92 9.92L8.33 13.5H17.5V3.5H19.5V15.5H8.33L11.92 19.08L10.5 20.5L4.5 14.5L10.5 8.5Z',
      key: '1jk045',
    },
  ],
]);

export default SubdirectoryArrowLeft;
